export function DatabaseAddIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" role="img">
      <title>Database add</title>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.33}
        d="M14 3.334c0 1.105-2.686 2-6 2s-6-.895-6-2m12 0c0-1.105-2.686-2-6-2s-6 .895-6 2m12 0v4.667M2 3.334v9.333c0 .433.42.854 1.197 1.2.778.346 1.803.8 4.803.8M2 8.001c-.001.372.31.738.9 1.055.589.317 1.767.945 3.767.945m4.666-2v3.333m0 0h3.334m-3.334 0v3.333m0-3.333H8"
      />
    </svg>
  )
}
